// Poofiz product cards and grids: swatch photo preview, one-tap add to cart, "show more".
// Everything uses event delegation on document, so cards that
// arrive later ("show more", cart re-renders) work without re-initialising.

(() => {
  if (window.cozyCards) return;
  window.cozyCards = true;

  const strings = () => window.cozyCartStrings || {};
  const routes = () => window.routes || {};

  // Picking a color on a card previews that color's photo (when the variant has one).
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-card-form] input[name="id"][data-img-src]');
    if (input) {
      const img = input.closest('[data-card]')?.querySelector('[data-card-img]');
      if (img) {
        img.srcset = input.dataset.imgSrcset;
        img.src = input.dataset.imgSrc;
      }
    }
  });

  // One-tap add: same contract as the product page (cart/add.js + cozy:cart-add for the drawer).
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-card-form]');
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector('[data-card-add]');
    const error = form.querySelector('[data-card-error]');
    if (button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;

    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
      const id = Number(new FormData(form).get('id'));
      const res = await fetch(`${routes().cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || strings().error);

      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 1800);
      const handled = !document.dispatchEvent(new CustomEvent('cozy:cart-add', { detail: data, cancelable: true }));
      if (!handled) window.location.href = routes().cart_url || '/cart';
    } catch (err) {
      error.textContent = err.message || strings().error;
      error.hidden = false;
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  });

  // "Show more": fetch the next page, append its grid items, move the link on (or remove it).
  // Without JS it is a normal link to page 2.
  document.addEventListener('click', async (e) => {
    const more = e.target.closest('[data-load-more]');
    if (!more || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    if (more.getAttribute('aria-busy')) return;
    more.setAttribute('aria-busy', 'true');
    const wrap = more.closest('[data-paginated]');

    try {
      const html = await fetch(more.href).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextWrap = doc.getElementById(wrap.id) || doc.querySelector('[data-paginated]');
      const items = [...nextWrap.querySelector('[data-grid]').children];
      wrap.querySelector('[data-grid]').append(...items);

      const nextMore = nextWrap.querySelector('[data-load-more]');
      const count = wrap.querySelector('[data-more-count]');
      const nextCount = nextWrap.querySelector('[data-more-count]');
      if (count && nextCount) count.textContent = nextCount.textContent;
      if (nextMore) {
        more.href = nextMore.href;
        more.removeAttribute('aria-busy');
      } else {
        more.remove();
      }
      items[0]?.querySelector('.cozy-card__title a, a[href]')?.focus({ preventScroll: true });
    } catch {
      window.location.href = more.href;
    }
  });
})();
